/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import { endConsultVideoRoom } from 'Redux/modules/webChat/actions';
import { func, shape, number, any } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useConversation, {
  useConversationActiveId,
} from 'Containers/Teleconsult/hooks/useConversation';
import toast from 'react-hot-toast';

import ZoomView from './ZoomView';
import useActiveMediaFailed from './hooks/useActiveMediaFailed';
import useAutoPlayAudioFailed from './hooks/useAutoPlayAudioFailed';
import useZoomTranscript from './hooks/useZoomTranscript';

function ZoomContainer({ roomInfo, handleCloseVideo, zoomClient, showError, audioRef, logEvents }) {
  const dispatch = useDispatch();
  const conversationActiveId = useConversationActiveId();
  const conversationActive = useConversation(conversationActiveId);
  const { latestConsult } = conversationActive || { latestConsult: null };
  const { patient } = latestConsult || { patient: {} };
  const [ava, setAva] = useState();
  const [isAttentionAudio, setIsAttentionAudio] = useState(false);

  const { name } = useSelector(state => state.doctors.profile);

  useActiveMediaFailed(zoomClient, showError);
  useAutoPlayAudioFailed(zoomClient, () => {
    toast(<div>Please unmute your microphone to start audio</div>, {
      position: 'top-center',
      duration: 3000,
    });
    setIsAttentionAudio(true);
  });

  useZoomTranscript(zoomClient, roomInfo.id);

  const handleEndCall = reason => {
    dispatch(endConsultVideoRoom(roomInfo.id, { endReason: reason }));
  };

  const onbeforeunload = e => {
    e = e || window.event;
    if (e) {
      e.returnValue = 'Sure?';
    }
    return 'Sure?';
  };

  useEffect(() => {
    window.onbeforeunload = onbeforeunload;
    return () => {
      window.onbeforeunload = null;
    };
  }, [onbeforeunload]);

  useEffect(() => {
    if (latestConsult?.id === roomInfo?.consultId) setAva(patient?.avatarUrl);
  }, [patient?.avatarUrl]);

  return (
    <ZoomView
      roomInfo={roomInfo}
      currentUserName={name}
      onCloseVideo={handleCloseVideo}
      handleEndCall={handleEndCall}
      displayName={patient?.fullName || ''}
      avatar={ava}
      zoomClient={zoomClient}
      showError={showError}
      isAttentionAudio={isAttentionAudio}
      setIsAttentionAudio={setIsAttentionAudio}
      audioRef={audioRef}
      logEvents={logEvents}
      recording={roomInfo.audioRecordingEnabled}
    />
  );
}

ZoomContainer.propTypes = {
  handleCloseVideo: func.isRequired,
  showError: func.isRequired,
  zoomClient: any,
  audioRef: any,
  roomInfo: shape({ id: number }).isRequired,
  logEvents: func.isRequired,
};

export default ZoomContainer;
